import CuratedStreamsCarousel, { CuratedStreamsCarouselProps } from './CuratedStreamsCarousel'
import CuratedStreamsCarouselContainer from './CuratedStreamsCarouselContainer'

export { CuratedStreamsCarousel, type CuratedStreamsCarouselProps }
export default CuratedStreamsCarouselContainer
